import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
    // state提供数据
  state: {
    activeIndex: "0"
  },
   mutations: {
    // 修改状态的方法
    setMyData(state, data) {
      state.activeIndex = data;
    }
  },
})

export default store

